module.exports = __webpack_public_path__ + "5ad45c83f40a5496a549e296180a23d9.svg";